module.exports = __webpack_public_path__ + "static/media/evcouplings_logo_1x.9ae8588d.png";